import { utcDate } from '../format';
import type { DriftListOut } from '../types';

interface DriftListProps {
  driftList: DriftListOut;
}

export function DriftList({ driftList }: DriftListProps) {
  if (driftList.items.length === 0) {
    return (
      <div className="empty">
        <p>No drift detected. All cached values match live OpenRouter state.</p>
      </div>
    );
  }

  return (
    <div>
      <table className="keys">
        <caption className="sr-only">Detected drift between cached and live key state</caption>
        <thead>
          <tr>
            <th scope="col">Key</th>
            <th scope="col">Team / Owner</th>
            <th scope="col">Fields</th>
            <th scope="col">Detected</th>
          </tr>
        </thead>
        <tbody>
          {driftList.items.map((drift, idx) => (
            <tr key={`drift-${idx}`}>
              <td>
                <div className="key-name">{drift.name ?? drift.openrouter_key_hash}</div>
              </td>
              <td>
                {drift.team_name && <div>{drift.team_name}</div>}
                {drift.owner_email && <div className="muted small">{drift.owner_email}</div>}
                {!drift.team_name && !drift.owner_email && <span className="muted">unknown</span>}
              </td>
              <td>
                <ul className="issues" style={{ margin: 0 }}>
                  {drift.fields.map((field) => (
                    <li key={field.field} className="issue issue-warning" style={{ marginTop: 0 }}>
                      <strong>{field.field}:</strong>
                      <div style={{ fontSize: '11px', marginTop: '2px' }}>
                        cached: {field.cached ?? '(null)'}
                      </div>
                      <div style={{ fontSize: '11px' }}>live: {field.live ?? '(null)'}</div>
                    </li>
                  ))}
                </ul>
              </td>
              <td className="numeric small">{drift.detected_at ? utcDate(drift.detected_at) : 'unknown'}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
